import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { MapIntegrationPlanForm } from "../MapIntegrationPlanForm";
import { EditMapIntegrationPlanModalProps } from "./types";
import { useEditMapIntegrationPlanModal } from "./controller";

export const EditMapIntegrationPlanModal = React.memo(({ modalRef }: EditMapIntegrationPlanModalProps) => {
  const translate = useTranslate();

  const { methods, handleSubmit, isPending } = useEditMapIntegrationPlanModal(modalRef);

  return (
    <Modal
      ref={modalRef}
      title={translate("subscription_mapintegrationplan_admin.titles.edit")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <MapIntegrationPlanForm />
    </Modal>
  );
});
